exports.components = {
  "component---src-pages-404-tsx": () => import("./../../../src/pages/404.tsx" /* webpackChunkName: "component---src-pages-404-tsx" */),
  "component---src-pages-index-tsx": () => import("./../../../src/pages/index.tsx" /* webpackChunkName: "component---src-pages-index-tsx" */),
  "component---src-pages-update-log-tsx": () => import("./../../../src/pages/updateLog.tsx" /* webpackChunkName: "component---src-pages-update-log-tsx" */),
  "slice---src-components-header-tsx": () => import("./../../../src/components/Header.tsx" /* webpackChunkName: "slice---src-components-header-tsx" */)
}

